import { render, staticRenderFns } from "./RoadDynamics.vue?vue&type=template&id=2c57d0b6&scoped=true&"
import script from "./RoadDynamics.vue?vue&type=script&lang=js&"
export * from "./RoadDynamics.vue?vue&type=script&lang=js&"
import style0 from "./RoadDynamics.vue?vue&type=style&index=0&id=2c57d0b6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c57d0b6",
  null
  
)

export default component.exports